<template>
  <div>
    <slot />
    <default-footer />
  </div>
</template>

<script>
import DefaultFooter from "@/components/footer/DefaultFooter.vue";
export default {
  components: {
    DefaultFooter,
  },
};
</script>

<style lang="scss" scoped>
</style>
